module.exports = __webpack_public_path__ + "static/media/investor.f0b00733.png";